import React, { useState, useEffect } from 'react'
import { Navbar, Footer } from '../container'
import { Helmet } from "react-helmet";
import ContenidoTesis from '../components/BiografiaTesis/BiografiaTesis';
//import HeaderTesis from '../components/BiografiaTesis/headerTesis';

const Tesis = () => {
  

  return (
    <div className='App'>
      <Helmet>
        <meta charset="utf-8" />
        <title>Tesis Doctoral - Ricardo Salinas</title>
        
      </Helmet>
      <Navbar />
      <ContenidoTesis></ContenidoTesis>
      


      <Footer />
    </div>
  )
}

export default Tesis
